import $ from "jquery";

import './Header.scss';
import './Header.sticky.scss';
import './Header.menu.scss';

import InfoPanel from "./InfoPanel/InfoPanel";

const scrollOffset = 50;

export default class Header {

    init() {
        this.initStickyHeader();
        this.initMobileHeader();
        this.initHeaderCollapse();
    }

    initStickyHeader() {
        let header = document.getElementById('main-header');
        window.onscroll = () => {

            if (window.pageYOffset > scrollOffset && !header.classList.contains('sticky')) {
                header.classList.add('sticky');
            } else if (window.pageYOffset <= scrollOffset && header.classList.contains('sticky')){
                header.classList.remove('sticky');
            }

        };
    }

    initMobileHeader() {
        let hamburgerBtn = $(".hamburger-btn");
        let menu = $(".header-menu");

        hamburgerBtn.click(function(){
            $(this).toggleClass("open");
            $("body").toggleClass("no-scroll");
            menu.slideToggle(300);
        })
    }

    initHeaderCollapse() {
        $('.menu-item.after-arr').click(function () {
            $(this).toggleClass("active");
        });
    }
}


// WEBPACK FOOTER //
// ./Src/Shared/Header/Header.js